<template>
  <div class="human-capitalt-view-past">
    <h2 class="heading-lv2">{{this.femaleManager.year}}年{{this.month}}月期</h2>
    <div class="human-capitalt-data-wrap">
      <div class="human-capitalt-data-wrap__table01">
        <p class="l-formGroup__label u-mb10">管理職数</p>
        <table class="human-capitalt-data-table">
          <colgroup>
            <col style="width: 50%;">
            <col>
          </colgroup>
          <tbody>
            <tr>
              <th>男性</th>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="femaleManager.maleManager" :unit="this.unit"/></span>
              </td>
            </tr>
            <tr>
              <th>女性</th>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="femaleManager.femaleManager" :unit="this.unit"/></span>
              </td>
            </tr>
            <tr class="human-capitalt-data-table__bordertop">
              <th>全社</th>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="this.sumOfManager" :unit="this.unit"/></span>
              </td>
            </tr>
          </tbody>
        </table>
      </div><!--/human-capitalt-data-wrap__table01-->

      <div class="human-capitalt-data-wrap__arrow"></div>

      <div class="human-capitalt-data-wrap__results">
        <div class="human-capitalt-data-results">
          <div class="human-capitalt-data-results__text">
            女性管理職比率
            <strong><Currency :value="this.calFemaleManagerRatio"/></strong>%
          </div>
        </div>
      </div>

    </div><!--/human-capitalt-data-wrap-->
    <div class="l-contentsGrid2 u-mt30">
      <div class="l-contentsGrid2__item">
        <div>
          <div class="l-formGroup">
            <label class="l-formGroup__label u-mb10">実績に関するメモ</label>
            <p  class="l-text" style="white-space: pre-line;" v-html="repalceLink(femaleManager.resultMemo)"></p>
          </div>
        </div>
      </div>
      <div class="l-contentsGrid2__item">
        <div class="l-contentsMemo">
          <div class="l-formGroup">
            <div class="l-contentsMemo__title">
              <label class="l-formGroup__label">具体的なアクション</label>
            </div>
            <div class="l-contentsMemo__body">
                <div>
                  <p  class="l-text" style="white-space: pre-line;" v-html="repalceLink(femaleManager.actionMemo)"></p>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div><!--/l-contentsGrid2 u-mt30-->
  </div><!--/human-capitalt-data-past-->

</template>

<script>
import Currency from '@/components/parts/human_capital/parts/Currency.vue';

export default {
  components: {
    Currency,
  },
  props: {
    // 表示年度の財務情報データ
    femaleManager: {},
    month: null,
    num: null,
  },
  data() {
    return {
      unit: '名',
      unit2:'％',
    }
  },
  computed: {
    sumOfManager() {
      if ( !(this.femaleManager.maleManager!=null && this.femaleManager.femaleManager!=null) ) {
        return null;
      }else if ( String(this.femaleManager.maleManager).length * String(this.femaleManager.femaleManager).length ==  0 ) {
        return null;
      }else if ( isNaN(this.femaleManager.maleManager) || isNaN(this.femaleManager.femaleManager)) {
        return null;
      }else{
        return Number(this.femaleManager.maleManager) + Number(this.femaleManager.femaleManager);
      }
    },
    calFemaleManagerRatio() {
      if ( this.sumOfManager != null && this.femaleManager.femaleManager != null ){
        if(this.sumOfManager == 0) return null;
        if(this.femaleManager.femaleManager == 0) return 0;
        let val = (this.femaleManager.femaleManager / this.sumOfManager) * 100 * 10; // 小数点以下１まで表示なので10
        return Math.round(val)/10;
      }else{
        return null;
      }
    }
  },
  watch: {
    femaleManager() {
      this.inputFemaleManager();
    },
  },
  created: function () {

  },
  mounted() {

  },
  methods: {
    inputFemaleManager() {
      this.$emit("change-female-manager-detail", {
        femaleManager: this.femaleManager,
        month: this.month,
        num: this.num,
      });
    },
    repalceLink(text) {
      return text ? text.replace(/(https?:\/\/[^\s]*)/g, "<a href='$1'style='text-decoration: underline; color: #0070be;' target='_blank' rel='noopener noreferrer'>$1</a>") : '';
    },

  }
}

</script>
